<template>
    <v-container class="pt-1 pb-12 py-sm-12">
  <v-row class="d-none d-sm-flex">
    <v-col :cols="12">
        <div class="title-container d-flex justify-space-between align-center">
          <div class="title-block">
            <div class="d-flex align-center ga-3">
              <span class="page-title">{{ page.title }}</span>
              <v-menu offset-y transition="slide-y-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small color="primary" text v-bind="attrs" v-on="on">
                    <v-icon left>mdi-help-circle-outline</v-icon>Ajuda
                  </v-btn>
                </template>
                <v-card min-width="380px">
                  <v-card-title class="text-h6 font-weight-bold pb-2">
                    <v-icon small class="mr-2">mdi-lightbulb-on</v-icon>Ajuda dos Campos
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text class="pt-3 pb-3">
                    <div class="mb-3"><p class="font-weight-bold text-caption mb-1">🔖 Código</p><p class="text-caption grey--text">Palavra ou número que o cliente digita no totem para ganhar desconto</p></div>
                    <v-divider class="my-2"></v-divider>
                    <div class="mb-3">
                      <p class="font-weight-bold text-caption mb-1">1️⃣ Apenas novos clientes</p>
                      <p class="text-caption grey--text">Se marcado, apenas novos clientes poderam utilizar este cupom.</p>
                    </div>
                    <v-divider class="my-2"></v-divider>
                    <div class="mb-3"><p class="font-weight-bold text-caption mb-1">🔢 Limite de utilização</p><p class="text-caption grey--text">Quantas vezes no total esse cupom pode ser usado. Deixe em branco para ilimitado</p></div>
                    <v-divider class="my-2"></v-divider>
                    <div class="mb-3"><p class="font-weight-bold text-caption mb-1">🖥️ Tipo de máquina</p><p class="text-caption grey--text">Se o cupom vale só pra lavar, só pra secar, ou para qualquer máquina</p></div>
                    <v-divider class="my-2"></v-divider>
                    <div class="mb-3"><p class="font-weight-bold text-caption mb-1">💲 Tipo de desconto</p><p class="text-caption grey--text">Porcentagem = tira X% do valor. Valor = tira R$ X do total</p></div>
                    <v-divider class="my-2"></v-divider>
                    <div class="mb-3"><p class="font-weight-bold text-caption mb-1">📅 Datas e Horários</p><p class="text-caption grey--text">De quando até quando e em que horário o cupom pode ser usado</p></div>
                    <v-divider class="my-2"></v-divider>
                    <div><p class="font-weight-bold text-caption mb-1">📆 Dias da semana</p><p class="text-caption grey--text">Em quais dias da semana o cupom é aceito</p></div>
                  </v-card-text>
                </v-card>
              </v-menu>
            </div>
            <v-breadcrumbs class="app-breadcrumb" divider="›" :items="dataset.breadcrumbItems"></v-breadcrumbs>
          </div>
          <div class="button-group">
           <v-btn id="btnBack" type="button" elevation="0" outlined exact style="color: #3BA5DB !important; border-color: #3BA5DB !important;" to="/cupons">Voltar</v-btn>
            <v-btn v-if="page.isNew" id="btnSave" type="button" elevation="0" color="primary" dark
                @click="add" :loading="dataset.loading">Salvar</v-btn>
            <v-btn v-else type="button" id="btnUpdate" elevation="0" color="primary" dark @click="update"
                :loading="dataset.loading">Salvar</v-btn>
           <v-btn type="button" id="btnDelete" elevation="0" style="background-color: #f44336 !important; color: white !important;" @click="remove()">remover</v-btn>
          </div>
        </div>
    </v-col>
</v-row>

<v-row class="d-sm-none d-lg-none d-md-flex">
    <v-col :cols="12">
        <div class="title-container">
     <div class="title-block">
    <div class="d-flex align-center">
      <span class="page-title">{{ page.title }}</span>
      <v-btn icon small color="primary" class="ml-2" @click="dialogAjudaMobile = true">
          <v-icon>mdi-help-circle-outline</v-icon>
      </v-btn>
    </div>
    <v-breadcrumbs class="app-breadcrumb" divider="›" :items="dataset.breadcrumbItems"></v-breadcrumbs>
</div>
        </div>
    </v-col>
</v-row>

<v-row class="d-sm-none d-lg-none d-md-flex">
    <v-col>
        <div class="button-group">
   <v-btn id="btnBack" type="button" elevation="0" outlined exact style="color: #3BA5DB !important; border-color: #3BA5DB !important;" to="/cupons">Voltar</v-btn>
    <v-btn v-if="page.isNew" id="btnSave" type="button" elevation="0" color="primary" dark
        @click="add" :loading="dataset.loading">Salvar</v-btn>
    <v-btn v-else type="button" id="btnUpdate" elevation="0" color="primary" dark @click="update"
        :loading="dataset.loading">Salvar</v-btn>
    <v-btn type="button" id="btnDelete" elevation="0" style="background-color: #FF3636 !important; color: white !important;" @click="remove()">remover</v-btn>
</div>
    </v-col>
</v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                           <v-card class="card-form-outlined">
    <v-card-title class="card-group-title d-flex align-center justify-space-between">
        <span>Detalhes</span>
      <span v-if="!page.isNew && dataset.data.qtdUtilizacaoCupom != null"
            class="font-weight-medium d-flex align-center" style="color:#1976D2; font-size:15px;">
            <v-icon small color="primary" class="mr-1">mdi-ticket-percent-outline</v-icon>
            {{ dataset.data.qtdUtilizacaoCupom }} utilizações
        </span>
    </v-card-title>
                                <v-card-text>
                                    <v-row>
    <!-- Linha 1: Dados Básicos e o Checkbox isolado no desktop -->
  <v-col cols="12" sm="6" md="3" class="pb-3"> 
    <v-text-field dense label="Código" v-model="dataset.data.codigo" required
        :rules="[$rules.required, $rules.maxlength(dataset.data.codigo, 20)]"
        outlined hide-details="auto">
    </v-text-field>
</v-col>

<v-col cols="12" sm="6" md="3" class="pb-3 d-flex align-center"> 
    <v-checkbox dense label="Apenas novos clientes"
        v-model="dataset.data.primeiroUso"
        hint="Apenas novos clientes poderam utilizar este cupom"
        hide-details="auto" class="mt-0 pt-0">
    </v-checkbox>
</v-col>

<v-col cols="12" sm="6" :md="page.isNew ? '3' : '3'" class="pb-3"> 
    <v-text-field dense type="number" label="Limite de utilização"
        v-model="dataset.data.limiteUtilizacao" outlined hide-details="auto">
    </v-text-field>
</v-col>

<v-col cols="12" sm="6" :md="page.isNew ? '3' : '3'" class="pb-3"> 
    <v-select dense :items="dataset.machineTypes" label="Tipo de máquina"
        v-model="dataset.data.tipoMaquina" item-value="id" item-text="name"
        outlined hide-details="auto" clearable>
    </v-select>
</v-col>
</v-row>

<v-row class="mt-sm-2">
    <!-- Linha 2: Valores e Status -->
    <v-col cols="12" sm="4" md="3" class="pb-3">
        <v-select dense :items="dataset.couponTypes" label="Tipo de desconto"
            v-model="dataset.data.tipoDesconto" item-value="value" item-text="name"
            outlined :rules="[$rules.required]" required hide-details="auto">
        </v-select>
    </v-col>
    <v-col cols="12" sm="4" md="5" class="pb-3">
        <v-currency-field label="Valor" dense v-model="dataset.data.valorDesconto"
            :prefix="dataset.data.tipoDesconto == 'PORCENTAGEM' ? '%' : 'R$'"
            :allowNegative="false" hide-details="auto" outlined required
            :rules="[$rules.required]">
        </v-currency-field>
    </v-col>
    <v-col cols="12" sm="4" md="4" class="pb-3"> 
        <v-select dense :items="dataset.statusTypes" label="Status"
            v-model="dataset.data.ativo" item-value="value" item-text="name"
            outlined :rules="[$rules.required]" required hide-details="auto">
        </v-select>
    </v-col>
</v-row>

<v-row class="mt-sm-2">
    <!-- Linha 3: Datas -->
    <v-col cols="12" sm="6" class="pb-3">
        <v-text-field v-model="dataset.data.dataInicio" type="date" dense
            label="Data início" outlined :rules="[$rules.required]" required
            hide-details="auto">
        </v-text-field>
    </v-col>
    <v-col cols="12" sm="6" class="pb-3">
        <v-text-field v-model="dataset.data.dataFim" type="date" dense
            label="Data fim" outlined hide-details="auto">
        </v-text-field>
    </v-col>
</v-row>

<v-row class="mt-sm-2">
    <!-- Linha 4: Horários -->
    <v-col cols="12" sm="6" class="pb-3">
        <v-text-field v-model="dataset.data.horaInicio" type="time" dense
            label="Hora início" outlined :rules="[$rules.required]" required
            hide-details="auto">
        </v-text-field>
    </v-col>
    <v-col cols="12" sm="6" class="pb-3">
        <v-text-field v-model="dataset.data.horaFim" type="time" dense
            label="Hora fim" outlined :rules="[$rules.required]" required
            hide-details="auto">
        </v-text-field>
    </v-col>
</v-row>
                                </v-card-text>

                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <v-row v-if="resumoCupom">
                <v-col cols="12">
                    <v-card class="card-form-outlined">
                        <v-card-title class="card-group-title">
                            <v-icon small class="mr-2">mdi-eye-outline</v-icon>Resumo do cupom
                        </v-card-title>
                        <v-card-text>
                            <p class="text-body-2">{{ resumoCupom }}</p>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12">
                    <v-card class="card-form-outlined">
                        <v-card-title class="card-group-title">Dias da semana</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col v-for="(day, index) in dataset.daysOfWeek" :key="index" cols="12" sm="6" md="4">
                                    <v-checkbox :label="day.name" :value="day.value" v-model="dataset.data.diaDaSemana"
                                        :rules="[$rules.required]" hide-details="auto" dense></v-checkbox>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-form>
<v-dialog v-model="dialogAjudaMobile" scrollable content-class="popup-mobile-dialog">
    <v-card>
        <div class="popup-mobile-header">
            <span class="popup-mobile-header-title">
                <v-icon small class="mr-2">mdi-lightbulb-on</v-icon>Ajuda dos Campos
            </span>
            <v-btn icon small class="popup-mobile-close" @click="dialogAjudaMobile = false">
                <v-icon size="18">mdi-close</v-icon>
            </v-btn>
        </div>
        <v-divider></v-divider>
        <v-card-text class="pt-3 pb-3">
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">🔖 Código</p><p class="text-caption grey--text">Palavra ou número que o cliente digita no totem para ganhar desconto</p></div>
            <v-divider class="my-2"></v-divider>
            <div class="mb-3">
              <p class="font-weight-bold text-caption mb-1">1️⃣ Apenas primeiro uso</p>
              <p class="text-caption grey--text">Se marcado, cada cliente só pode usar este cupom uma vez</p>
              <p class="text-caption red--text font-weight-bold">⚠️ Necessário o cadastro do cliente habilitado!</p>
            </div>
            <v-divider class="my-2"></v-divider>
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">🔢 Limite de utilização</p><p class="text-caption grey--text">Quantas vezes no total esse cupom pode ser usado. Deixe em branco para ilimitado</p></div>
            <v-divider class="my-2"></v-divider>
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">🖥️ Tipo de máquina</p><p class="text-caption grey--text">Se o cupom vale só pra lavar, só pra secar, ou para qualquer máquina</p></div>
            <v-divider class="my-2"></v-divider>
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">💲 Tipo de desconto</p><p class="text-caption grey--text">Porcentagem = tira X% do valor. Valor = tira R$ X do total</p></div>
            <v-divider class="my-2"></v-divider>
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">📅 Datas e Horários</p><p class="text-caption grey--text">De quando até quando e em que horário o cupom pode ser usado</p></div>
            <v-divider class="my-2"></v-divider>
            <div><p class="font-weight-bold text-caption mb-1">📆 Dias da semana</p><p class="text-caption grey--text">Em quais dias da semana o cupom é aceito</p></div>
        </v-card-text>
    </v-card>
</v-dialog>
    </v-container>
</template>

<script>
import axios from "axios"
import { eventHub } from "@/main"

import machineTypes from "@/common/data/machine-types.data"

export default {
    name: "MachineDetails",

    data: () => ({
        page: {
            title: "",
        },
        dialogAjudaMobile: false,
        dataset: {
            breadcrumbItems: [],
            upboxes: [],
            machineTypes: [{ id: null, name: 'Todos' }, ...machineTypes],
            daysOfWeek: [
                { value: "DOMINGO", name: "DOMINGO" },
                { value: "SEGUNDA", name: "SEGUNDA" },
                { value: "TERCA", name: "TERÇA" },
                { value: "QUARTA", name: "QUARTA" },
                { value: "QUINTA", name: "QUINTA" },
                { value: "SEXTA", name: "SEXTA" },
                { value: "SABADO", name: "SÁBADO" }
            ],
            statusTypes: [{ value: true, name: "Ativo" }, { value: false, name: "Inativo" }],
            couponTypes: [{ value: 'PORCENTAGEM', name: 'PORCENTAGEM' }, { value: 'VALOR', name: 'VALOR' }],
            data: {
                diaDaSemana: []
            },
            loading: false,
            operation: null,
        },
        dataForm: {
            validForm: true,
            updateLoading: false,
            removeLoading: false,
        },
    }),

   mounted() {
  eventHub.$on('CHANGE-OPERATION', () => {
    this.$router.push('/cupons');
  });

  this.getSelectedOperation();

  if (!this.dataset.operation) {
    this.$dialog.notify.error('Nenhuma operação selecionada!', { position: 'top-right', timeout: 5000 });
    return;
  }

  this.loadData();
},

    destroyed() {
        eventHub.$off('CHANGE-OPERATION')
    },

     computed: {
        resumoCupom() {
            const d = this.dataset.data;
            if (!d.codigo && !d.tipoDesconto && !d.valorDesconto) return null;

           const formatarDias = (dias) => {
                const singular = {
                    DOMINGO: 'no domingo', SEGUNDA: 'na segunda-feira', TERCA: 'na terça-feira',
                    QUARTA: 'na quarta-feira', QUINTA: 'na quinta-feira', SEXTA: 'na sexta-feira', SABADO: 'no sábado'
                };
                const plural = {
                    DOMINGO: 'aos domingos', SEGUNDA: 'às segundas-feiras', TERCA: 'às terças-feiras',
                    QUARTA: 'às quartas-feiras', QUINTA: 'às quintas-feiras', SEXTA: 'às sextas-feiras', SABADO: 'aos sábados'
                };
                const usarPlural = Number(d.limiteUtilizacao) > 1 || !d.limiteUtilizacao;

                if (dias.length === 1) {
                    return usarPlural ? plural[dias[0]] : singular[dias[0]];
                }

                const traduzidos = dias.map(dia => usarPlural ? plural[dia] : singular[dia]);
                const ultimo = traduzidos.pop();
                return traduzidos.join(', ') + ' e ' + ultimo;
            };

            let partes = [];

            if (d.codigo) {
                partes.push(`O cupom ${d.codigo.toUpperCase()}`);
            } else {
                partes.push('Este cupom');
            }

           if (d.tipoDesconto && d.valorDesconto) {
    const valor = d.tipoDesconto === 'PORCENTAGEM'
        ? `${d.valorDesconto}% de desconto`
        : `R$ ${Number(d.valorDesconto).toFixed(2).replace('.', ',')} reais de desconto por máquina`;
    partes.push(`dá ${valor}`);
}

            if (d.tipoMaquina === 'LAVAR') partes.push('válido somente para lavagem');
            else if (d.tipoMaquina === 'SECAR') partes.push('válido somente para secagem');
            else if (d.tipoMaquina == null) partes.push('válido para qualquer máquina');

            if (d.dataInicio && d.dataFim) {
                const ini = d.dataInicio.split('-').reverse().join('/');
                const fim = d.dataFim.split('-').reverse().join('/');
                partes.push(`pode ser usado de ${ini} até ${fim}`);
            } else if (d.dataInicio) {
                const ini = d.dataInicio.split('-').reverse().join('/');
                partes.push(`pode ser usado a partir de ${ini}`);
            }

            if (d.horaInicio && d.horaFim) {
                partes.push(`no horário das ${d.horaInicio} às ${d.horaFim}`);
            }

            if (d.limiteUtilizacao) {
                partes.push(`com limite de ${d.limiteUtilizacao} uso${d.limiteUtilizacao == 1 ? '' : 's'} no total`);
            }

            if (d.primeiroUso) {
                partes.push('e só pode ser usado por clientes novos (sem vendas registradas)');
            }

          if (d.diaDaSemana && d.diaDaSemana.length > 0 && d.diaDaSemana.length < 7) {
                partes.push(`somente ${formatarDias(d.diaDaSemana)}`);
            } else if (d.diaDaSemana && d.diaDaSemana.length === 7) {
                partes.push('todos os dias da semana');
            }

            return partes.join(', ') + '.';
        }
    },

    methods: {
        goBack() {
            this.$router.replace("/cupons");
        },

        getSelectedOperation() {
            this.dataset.operation = localStorage.getItem('operation');
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();

            await this.load();
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = `Detalhes do cupom`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Listagem de cupons",
                disabled: false,
                to: "/cupons",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.isNew ? `Incluir` : `Detalhes do cupom`,
                disabled: true,
                exact: true,
            });
        },

        async load() {

            if (this.page.isNew) return;

            this.dataset.loading = true

            try {
                const result = await axios.get(`/api/cupom/${this.$route.params.id}`);

                this.dataset.data = result.data

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataset.loading = false;
            }
        },

        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja adicionar o cupom <strong>${this.dataset.data.codigo}</strong>?`,
                title: 'Adicionar cupom',
                actions: {
                    false: 'Cancelar',
                    true: 'Adicionar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();
              console.log('tipoMaquina:', this.dataset.data.tipoMaquina)

            try {
                await axios.post(`/api/cupom`, payload, { config: { headers: { "Content-Type": "application/json" } } });

                this.$dialog.notify.info("Cupom salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            }  catch (error) {
    this.$dialog.notify.error(this.$codes(error), {
        position: 'top-right',
        timeout: 2000
    })
} finally {
    this.dataset.loading = false;
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja atualizar o cupom <strong>${this.dataset.data.codigo}</strong>?`,
                title: 'Atualizar cupom',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                await axios.put(`/api/cupom/${this.$route.params.id}`, payload, { config: { headers: { "Content-Type": "application/json" } } });

                this.$dialog.notify.info("Cupom salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async remove() {

    if (!this.$route.params.id) return;

    const proceedAction = await this.$dialog.confirm({
        text: 'Tem certeza que deseja continuar?',
        title: 'Excluir cupom',
        actions: {
            false: 'Cancelar',
            true: 'Excluir'
        }
    })

    if (!proceedAction) return;

    this.dataset.loading = true;

    try {
        await axios.delete(`/api/cupom/${this.$route.params.id}`)
        this.$dialog.notify.info("Cupom excluído com sucesso", { position: "top-right", timeout: 2000 });
        this.goBack()
    } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
            position: 'top-right',
            timeout: 2000
        })
    } finally {
        this.dataset.loading = false;
    }

},

buildPayload() {
    const data = {
        codigo: this.dataset.data.codigo,
        limiteUtilizacao: this.dataset.data.limiteUtilizacao,
        tipoMaquina: this.dataset.data.tipoMaquina,
        dataInicio: this.dataset.data.dataInicio,
        dataFim: this.dataset.data.dataFim,
        horaInicio: this.dataset.data.horaInicio,
        horaFim: this.dataset.data.horaFim,
        diaDaSemana: this.dataset.data.diaDaSemana,
        tipoDesconto: this.dataset.data.tipoDesconto,
        valorDesconto: this.dataset.data.valorDesconto,
        operacaoId: this.dataset.operation,
        ativo: this.dataset.data.ativo,
         primeiroUso: this.dataset.data.primeiroUso || false,
    }

    return data;
},

},
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}
.ga-3 { gap: 24px; }

.popup-mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 12px 16px;
}

.popup-mobile-header-title {
  font-size: 17px;
  font-weight: 700;
  color: #333;
  display: flex;
  align-items: center;
}

.popup-mobile-close.v-btn {
  background-color: #f0f0f0 !important;
  border-radius: 50% !important;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  box-shadow: none !important;
}

.popup-mobile-close.v-btn .v-icon {
  color: #555 !important;
}

.popup-mobile-dialog {
  border-radius: 12px;
}
</style>